import { ReactNode } from 'react';
import {
	GetPersonSecuritiesWithFeaturesAndRanksRes,
	SecurityFeatureType,
	SecurityRankDefinitionRes,
} from '@dealstack/shared/lib/generated';

export interface DroppableSharedProps {
	id: string;
	children: ReactNode;
	isOver: boolean;
	className?: string;
	disabled?: boolean;
}

export type SecurityWithRank = GetPersonSecuritiesWithFeaturesAndRanksRes;

export interface RankWithSecurities extends SecurityRankDefinitionRes {
	displaySortOrder: number;
	securities: SecurityWithRank[];
	validUnrankedSecurities: SecurityWithRank[];
	isPlaceholder?: boolean;
}

export enum DragAndDropId {
	sidebar = 'sidebar',
	rankingContent = 'ranking-content',
	placeholderRank = 'placeholder-rank',
}

/**
 * Display-only residue tier, synthesised when the issuer has no persisted residue rank. It must
 * never reach the API: it accepts no drops and is skipped by the reorder controls.
 */
export const VIRTUAL_RESIDUE_RANK_ID = 'virtual-residue-rank';

export interface UpsertSecurityRankParams {
	securityId: string;
	securityFeatureType: SecurityFeatureType;
	isMergedIncomeRight: boolean;
	rankId?: string;
}
